<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "RequestAttributeForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        field_type: null,
        required: false,
        active: true,
        // Le champ de tags travaille sur un tableau : il doit en trouver un dès la création,
        // sinon la première valeur saisie n'a nulle part où aller.
        choices: [],
        // Idem pour les familles : le rattachement est multiple.
        equipment_group_ids: [],
      },
      isBusy: false,
    };
  },
  computed: {
    options: function () {
      return {
        field_type_options: this.$store.getters["request_attribute/getFieldTypesForSelect"],
        // Racines et sous-familles, hiérarchisées (« -- » devant les sous-familles).
        equipment_group_ids_options: this.$store.getters["equipment_group/getAllForSelect"],
      };
    },
  },
  created() {
    this.$store.dispatch("request_attribute/getOptions");
    this.$store.dispatch("equipment_group/getAll");
  },
  mounted() {
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", { id: id, wait: true })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            // L'API sert les familles rattachées à plat ; le champ travaille sur leurs
            // identifiants, et doit trouver un tableau même sur un attribut sans famille.
            equipment_group_ids: item.equipment_group_ids || [],
            // L'API stocke les valeurs proposées en texte, une par ligne ; le champ les
            // manipule en tags. Retour au texte à l'envoi (cf. `submitFormatter` de la config).
            choices: item.choices
              ? item.choices.split("\n").map((text) => ({ text: text.trim() })).filter((tag) => tag.text)
              : [],
          };
          this.isBusy = false;
        });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/RequestAttribute/RequestAttributeForm.vue